import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateSendCandidateList = {
  sendCandidateList: { data: null, loading: false, error: null },
};

export const sendCandidateList = createAsyncThunk('user/sendCandidateList', async ({ vacancyId, data }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/vacancies/${vacancyId}/broadcast/candidates`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerSendCandidateList = {
  [sendCandidateList.pending]: (state) => {
    state.sendCandidateList.loading = true;
    state.sendCandidateList.error = null;
  },
  [sendCandidateList.fulfilled]: (state, action) => {
    state.sendCandidateList.loading = false;
    state.sendCandidateList.data = action.payload;
    state.sendCandidateList.error = null;
  },
  [sendCandidateList.rejected]: (state, action) => {
    state.sendCandidateList.loading = false;
    state.sendCandidateList.error = true;
  },
};
